import connect from './connect';
import SaveAsTemplate from './SaveAsTemplate';

export default connect(SaveAsTemplate);
export { SaveAsTemplateProps } from './SaveAsTemplate';
